module.exports = {"return":{"minions":{"homer.bardels.me":"f4:c5:36:66:c0:f5:d9:cd:9b:43:35:73:c0:1d:aa:cc:3e:7c:26:82:8d:28:42:69:17:47:93:70:c7:7f:38:ee"}}}


//////////////////
// WEBPACK FOOTER
// ./src/fixtures/get_key.homer.json
// module id = 1054
// module chunks = 0